import loadable from '@loadable/component';
import FullPageLoading from '../../components/Loading/FullPageLoading';

export const StatSingleLoadable = loadable(async () => import('./objective-stats-details/objective-stats-details.view'), {
  fallback: <FullPageLoading background="white" />,
});
